import { dispatcher, IEvent, ingenuity } from "@quest/base-core";
import { Main, SlotConstantsBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther/dist";
import { BannerScreenView } from "./BannerScreen/BannerScreenView";
import { BannerScreenController } from "./BannerScreen/BannerScreenController";
import { JackpotOutroView } from "./JackpotOutro/JackpotOutroView";
import { eventDispatchers } from "./Constants/EventDispatchers";
import { JackpotOutroController } from "./JackpotOutro/JackpotOutroController";
import { GrandOutroView } from "./GrandOutro/GrandOutroView";
import { GrandOutroController } from "./GrandOutro/GrandOutroController";
import { ClueRevealBannerController } from "./BannerScreen/ClueRevealBannerController";

export class MainGame extends Main {
  private jackpotOutroView: JackpotOutroView;
  private grandOutroView: GrandOutroView;
  private bannerView: BannerScreenView;

  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.INITIALIZE_CLUE_BANNER, this.initializeClueOutro, this);
    dispatcher.on(eventDispatchers.INITIALIZE_GRAND_CLUE_BANNER, this.initializeGrandClueOutro, this);
    dispatcher.on(eventDispatchers.ADD_MSG_BANNER_ON_TOP, this.addBannerOnTop, this);
  }
  
  protected unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.INITIALIZE_CLUE_BANNER, this.initializeClueOutro, this);
    dispatcher.off(eventDispatchers.INITIALIZE_GRAND_CLUE_BANNER, this.initializeGrandClueOutro, this);
    dispatcher.off(eventDispatchers.ADD_MSG_BANNER_ON_TOP, this.addBannerOnTop, this);
  }

  protected onAssetsLoaded(evt: IEvent): void {
    super.onAssetsLoaded(evt);
    this.initializeBannerScreen();
  }
  protected initializeBannerScreen(): void {
     this.bannerView = new BannerScreenView(
      ingenuity.currentGame.cache.getJSON(SlotConstantsBehavior.MAIN_DATA).bannerScreen
    );
    new BannerScreenController(this.bannerView);
    new ClueRevealBannerController(this.bannerView);
    this.addBannerOnTop();
  }
  private addBannerOnTop():void{
    ingenuity.currentGame.stage.addChild(this.bannerView);
  }
  private initializeClueOutro(): void {
    if (!this.jackpotOutroView) {
      this.jackpotOutroView = new JackpotOutroView(
        ingenuity.currentGame.cache.getJSON(SlotConstantsBehavior.MAIN_DATA).jackpotIntroOutro
      );
      new JackpotOutroController(this.jackpotOutroView);
    }
    ingenuity.currentGame.stage.addChild(this.jackpotOutroView);
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_FG_BUTTON_PANEL_ON_TOP);
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_BUTTON_PANEL_ON_TOP);
  }
  private initializeGrandClueOutro(): void {
    if (!this.grandOutroView) {
      this.grandOutroView = new GrandOutroView(
        ingenuity.currentGame.cache.getJSON(SlotConstantsBehavior.MAIN_DATA).grandOutro
      );
      new GrandOutroController(this.grandOutroView);
    }
    ingenuity.currentGame.stage.addChild(this.grandOutroView);
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_FG_BUTTON_PANEL_ON_TOP);
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_BUTTON_PANEL_ON_TOP);
  }
}
